import React from "react";
/** composants **/
import { Navbar } from '../Navbar';
import Footer from '../components/Footer';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

//img & icon
import { CheckIcon } from "@heroicons/react/20/solid";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import PrendreRdv from "./prendreRdv";
import BackHeaderTop from "../components/BackHeaderTop";
import BackHeaderBottom from "../components/BackHeaderBottom";
import GoogleAvis from "../components/GoogleAvis";
import VenteImg from '../img/vente-lead.png';
import AccompagnementClotere from '../components/AccompagnementClotere'
import CinqQuestionsAcheteur from "../components/CinqQuestionsAcheteur";
import Testimonials from "../components/Testimonials";


function Acheteur(args) {
    return (
        <>
            <Helmet>
                <title>Trouvez votre notaire pour votre achat immobilier – Simple, rapide et gratuit avec Clotere</title>
                <meta name="robots" content="index,follow" />
                <meta name="googlebot" content="index,follow" />
                <meta name='description' content='Trouvez le notaire pour représentez vos intêrets lors de votre achat immobilier.  Clotere vous accompagne en ligne, gratuitement et en toute simplicité. ' />
                <meta property="og:url" content="https://clotere.fr/notaire-acheteur" />
                <meta property="og:site_name" content="Clotere" />
                <meta property="og:image" content="https://clotere.fr/facebook-share-webp" />
                <meta property="og:type" content="website" />
            </Helmet>


            {/**header 2 */}
            <div className="relative rounded-4xl ">
                <BackHeaderTop />
                <Navbar user={args.user} />

                <div className="relative container ">

                    <header class="flex flex-row flex-wrap justify-center sm:py-10 items-center">
                        <div className="w-full sm:basis-1/2 p-3 sm:p-4 flex flex-col sm:gap-6 text-center">
                            <h1 className="font-medium text-transparent sm:!text-[50px] tracking-[0]  mb-0" >
                                <span className=" text-black">Offre d'achat acceptée ?<br/><span className="font-bold mt-2 text-indigo-800"> On vous guide vers le bon notaire</span> </span>
                            </h1>

                            <p className="text-lg font-semibold leading-7 sm:w-[80%] mb-0 mx-auto">
                                Clotere vous connecte au notaire qu'il vous faut et vous fait gagner 20 jours sur la signature.
                            </p>

                            {/** bloc bouton */}
                            <div>
                                <Link to="/onboard/mariage"
                                    type="button"
                                    className=" box-content mt-3 no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-3.5 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Trouver mon notaire immobilier
                                    <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                </Link>
                                <div className="flex flex-row gap-4 items-center mt-2 justify-center mb-6 sm:mb-0">
                                    
                                    <div className="flex flex-row gap-1 items-center text-xs">
                                        <CheckIcon className="size-4" />
                                        100% gratuit, et oui 🙂
                                    </div>
                                </div>
                            </div>

                            {/**bloc avis */}
                            <GoogleAvis/>
                            
                        </div>
                        <div className="w-full sm:basis-1/2 p-0 lg:p-5  sm:flex bg-transparent overflow-hidden rounded-2xl">
                            <img className="object-cover" src={VenteImg} alt="Vos démarches chez le notaire pour votre vente immobiliere" />

                        </div>
                    </header>
                </div>
                
                <BackHeaderBottom />
                {/** bloc ccm */}
                <section className="">
                    <div className="container">
                        <div className="py-12">
                            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-4 sm:gap-y-16 lg:max-w-none lg:grid-cols-4 justify-center">
                            <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500 text-white">
                                            <p className="flex mb-0">1</p>
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Ajoutez vos informations</p>
                                        <p className=" text-base mb-0">Quelques informations sur vous et votre offre d'achat suffisent pour démarrer le dossier.</p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500 text-white">
                                        <p className="flex mb-0">2</p>
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Choisissez votre notaire</p>
                                        <p className=" text-base mb-0">Un 1er rendez-vous gratuit avec votre notaire dès l'ouverture de votre dossier.</p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500 text-white">
                                        <p className="flex mb-0">3</p>
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Déposez vos documents simplement</p>
                                        <p className=" text-base mb-0">Déposez sur votre espace client les documents nécessaires pour la rédaction de vos actes.</p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                        <p className="flex mb-0">🥳</p>
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Signez votre acte authentique de vente</p>
                                        <p className=" text-base mb-0">A distance avec procuration ou sur place c'est vous qui choisissez ! Félicitations vous êtes propriétaire :)</p>

                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </section>

               <Testimonials type="achat"/>

                <AccompagnementClotere/>

            </div>
            <CinqQuestionsAcheteur />
            {/** section Blog 
            <section class=" mt-4 mb-4 flex flex-row flex-wrap justify-center items-center">
                <div className="bg-white  sm:py-20 ">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto text-center">
                            <h2 className="title-clotere">Bien comprendre votre passage chez le notaire pour <span className="font-bold text-indigo-800">votre achat immobilier</span></h2>

                        </div>
                        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-4 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-4 ">
                            {posts.map((post) => (
                                <article key={post.id} className="flex flex-col items-start gap-2 sm:gap-8 justify-center overflow-hidden bg-white shadow rounded-lg p-3">
                                    <p className="font-bold text-indigo-600 hover:bg-gray-100 m-0">{post.category.title} </p>

                                    <h3 className="mt-3 text-xl  font-semibold leading-7 text-gray-900 group-hover:text-gray-600">


                                        {post.title}

                                    </h3>

                                    <Link to={post.href}  className="btn-primary no-underline">Lire l'article</Link>

                                </article>
                            ))}
                        </div>
                        <div className="mx-auto max-w-2xl text-center">
                            <Link to="blog/notaire-et-mariage"
                                type="button"
                                className="mt-5 no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-3.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Consultez nos fiches pratiques notaire et achat immobilier
                                <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                            </Link>
                        </div>


                    </div>

                </div>

            </section>*/}
            <PrendreRdv />
            <Footer />
        </>
    );
}

export default Acheteur;